// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  uploadId: __t.u64(),
  contentHash: __t.string(),
  sourceUri: __t.string(),
  polyCount: __t.u32(),
  textureCount: __t.u16(),
  materialCount: __t.u16(),
  nodeCount: __t.u16(),
  boneCount: __t.u16(),
  sizeBytes: __t.u64(),
  vramEstimateMb: __t.u32(),
  geometryCodec: __t.string(),
  textureCodec: __t.string(),
  license: __t.string(),
  colliderShape: __t.string(),
  colliderUri: __t.string(),
  thumbnailUri: __t.string(),
};
